
/*

Vent

Global communications object.

Add / remove listeners, dispatch events.
Events can be listened to or dispatched by sub-category, for example:

// vent.on('domUpdate:header', myMethod.bind(this));

The object listening can be triggered by a generic
// vent.dispatch('domUpdate');

... or a more specific, categorized call (that will exclude irrelevant listeners)
// vent.dispatch('domUpdate:header');

This can be any number of levels deep, for example vent.dispatch('domUpdate:header:nav:navItem');
Good for expensive events. $$$

Listeners can be removed in bulk by leaving the specific callback blank in vent.off().

Last edited 02.07.17 by David Robbins

*/

class Vent {

	constructor(){

		this._vents;
		this._init();
	}

	_init(){

		// bloop bloop
	}

	// public methods

	on(event, callback, context){
		this._addListener(event, callback, context);
	}

	off(event, callback, context){
		this._removeListener(event, callback, context);
	}

	trigger(event, params){
		this._dispatchEvent(event, params);
	}

	// private methods

	_addListener(event, callback, context){

		if(typeof(context) === 'undefined'){ context = null; }

		let split = event.split(':');
		event = split[0].trim();

		//

		if(!this._vents){ this._vents = {}; }

		let dir = this._vents;
		let curDir = dir;

		for(let i=0, len=split.length; i<len; i++){

			let val = split[i].trim();

			if(val){

				let nextDir = curDir[val];

				if(!nextDir){
					nextDir = curDir[val] = {
						listeners: [],
						contexts: [],
						subCats: []
					};
				}

				curDir = nextDir;
				curDir.listeners.push(callback);
				curDir.contexts.push(context);
			}
			else {
				break;
			}
		}
	}

	_removeListener(event, callback, context){

		let split = event.split(':');
		event = split[0].trim();

		//

		if(!this._vents){ this._vents = {}; }
		let dir = this._vents;
		let curDir = dir;

		for(let i=0, len=split.length; i<len; i++){

			let val = split[i].trim();

			if(val){

				let nextDir = curDir[val];

				if(nextDir){

					curDir = nextDir;

					if(callback){

						// clear only listeners with matching callbacks

						let listenerPos = [];
						let contextPos = [];

						for(let k=0; k<curDir.listeners.length; k++){
							let tListener = curDir.listeners[k];
							if(tListener === callback){
								listenerPos.push(k);
							}
						}

						for(let k=0; k<curDir.contexts.length; k++){
							let tContext = curDir.contexts[k];
							if(tContext === context){
								contextPos.push(k);
							}
						}

						let doubleMatchPos = -1;

						for(let k=0; k<listenerPos.length; k++){
							if(listenerPos[k] === contextPos[k]){
								// console.log("_removeListener", event);
								doubleMatchPos = listenerPos[k];
								break;
							}
						}

						if(doubleMatchPos >= 0){
							curDir.listeners.splice(doubleMatchPos, 1);
							curDir.contexts.splice(doubleMatchPos, 1);
						}
					}
					else {

						// clear all listeners of type

						curDir.listeners = [];
					}
				}
				else {
					break;
				}
			}
			else {
				break;
			}
		}
	}

	_dispatchEvent(event, params){

		let split = event.split(':');
		event = split[0].trim();
		params = params ? params : {};

		let e = {event: event};
		let returnObj = params ? params : {};

		//

		if(!this._vents){ this._vents = {}; }
		let dir = this._vents;
		let curDir = dir;

		for(let i=0, len=split.length; i<len; i++){

			let val = split[i].trim();
			let nextDir = curDir[val];

			if(val && nextDir){

				curDir = nextDir;

				if(i === split.length - 1){

					// if at deepest level of specificity, trigger callback

					if(curDir){

						let curDirListeners = curDir.listeners;
						let curDirContexts = curDir.contexts;

						for(let k=0; k<curDirListeners.length; k++){
							let curCallback = curDirListeners[k];
							let curContext = curDirContexts[k];
							if(curCallback){
								curCallback.apply(curContext, [e, returnObj]);
							}
						}
					}
				}
			}
			else {
				break;
			}
		}
	}
}

module.exports = Vent;
